<template>
    <div class="w-full h-screen flex flex-col items-center justify-between bg-black">
        <div v-if="part==='searching'" class="flex h-full flex-col w-full overflow-y-auto justify-center items-center bg-white">
            <img src="../assets/loading.gif" class="w-full h-auto" />
        </div>
        <div v-if="part==='home'" class="flex flex-col w-full h-full overflow-y-auto">
            <div class="w-full py-4 px-4 border-b border-gray-500 flex flex-row justify-center sticky top-0 text-gray-500">
                <div>Scan ASSET</div>
            </div>
            <div><qrcode-stream @decode="onDecode"></qrcode-stream></div>
            <div v-if="error" class="bg-red-500 p-2 w-full">
                <span class="text-white">Wrong QR Code, please scan an asset code</span>
            </div>
            <div class="p-4">
                <label for="username" class="block text-sm font-medium leading-5 text-gray-500">
                    Search for Reg., VIN, Reference
                </label>
                <div class="mt-1 rounded-md shadow-sm">
                    <input v-model="reference" id="username" required="" class="appearance-none block w-full px-3 py-2 border bg-black text-gray-300 border-gray-500 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-500 transition duration-150 ease-in-out sm:text-sm sm:leading-5">
                </div>
                <div class="w-full pt-4 text-center">
                    <button @click="search" class="bg-gray-800 mb-2 p-2 px-16 text-indigo-400 rounded-lg focus:bg-indigo-200">
                        <i class="fa fa-search mr-2"></i> Search
                    </button>
                </div>
            </div>
        </div>
        <div v-if="part==='search'" class="flex flex-col w-full h-full overflow-y-auto bg-white">
            <div class="w-full py-4 px-4 border-b border-gray-200 flex flex-row justify-center sticky top-0">
                <div>Search asset</div>
            </div>
            <div v-for="item in assets" :key="item.autralis_id" @click="select(item)"  class="w-full h- p-2 border-b border-gray-200">
                <div class="flex flex-row justify-between">
                    <div class="truncate"><span class="font-bold">{{item.make_text}}</span> {{item.model_text}}</div>
                    <div ><span class="font-bold text-teal-500">{{item.slot_name}}</span></div>
                </div>
                <div><span class="font-bold text-indigo-600">{{item.registration}}</span> - {{item.vin}}</div>
            </div>
            <div>

            </div>
        </div>
        <div class="py-2 border-t border-gray-800 bg-black w-full text-center">
            <button @click="home" class="bg-gray-800 mb-2 p-2 px-16 text-indigo-400 rounded-lg focus:bg-indigo-200">Back</button>
        </div>
    </div>

</template>

<script>
    import { QrcodeStream } from 'vue-qrcode-reader';
    import axios from "axios";

    export default {
        name: "Asset",
        components : {
            QrcodeStream
        },
        data: function() {
            return {
                error: false,
                assets: [],
                asset: null,
                part: 'home',
                qrCode: '',
                reference: '',
            }
        },
        methods: {
            onDecode(code) {
                this.qrCode = code;
                if(!code.startsWith('asset:')) {
                    this.error = true;
                    return
                }
                this.error = false;
                this.part = 'searching';
                const url = "/manager/transport/sync/search/?searchText=";
                axios.get(url + 'barcode:' + this.reference).then(response => {
                    this.assets = response.data;
                    this.$emit("asset", this.assets[0]);
                });
            },
            home() {
                if(this.part==='home') {
                    this.$emit("back")
                } else {
                    this.part = 'home'
                }
            },
            search() {
                if(this.reference.trim().length<4) return;
                this.part = 'searching';
                const url = "/manager/transport/sync/search/?searchText=";
                axios.get(url + this.reference).then(response => {
                    this.assets = response.data;
                    this.part = 'search';
                });
            },
            select(asset) {
                this.asset = asset;
                this.$emit("asset", this.asset);
            }
        }
    }
</script>

<style scoped>

</style>